// test512
(512 && 0);
